/* Schnitt und Anzahl je Produkt, erzeugt aus kj-reviews.js (Stand: 350 Bewertungen).
   Wird von kj-shop.js fuer die Sterne auf den Produktkacheln gelesen.
   Der Schluessel muss im Produktnamen vorkommen, "Lernturm" findet also
   auch "Lernturm 3-in-1 mit Tafel". Die Reihenfolge zaehlt: der erste
   passende Schluessel gewinnt. Deshalb steht "Kletterset" vor
   "Kletterdreieck", denn der Set-Titel nennt auch das Dreieck.
   "Balancierweg" ist ein zweiter Name fuer den Balancierbalken, so heisst
   das Produkt im Admin. */
window.KJ_RATINGS = {"Kletterset": {"a": 4.7,"n": 46},"Lernturm": {"a": 4.7,"n": 64},"Balancierbalken": {"a": 4.9,"n": 150},"Balancierweg": {"a": 4.9,"n": 150},"Tisch- und Stuhl-Set": {"a": 4.8,"n": 18},"Rampe & Rutsche": {"a": 4.9,"n": 16},"Kletterbogen": {"a": 4.8,"n": 19},"Kletterdreieck": {"a": 4.8,"n": 37},"*": {"a": 4.8,"n": 350}};
